// Copyright 2021 Greener Power Solutions                 //
// This file is part of the Greener Power Solutions,      //
// and may not be altered, copied, redistributed, or sold //
// without specific permission.                           //
import { Stack } from '@mui/material';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ProjectLogo from 'components/assets/ProjectLogo';
import { DATE_FORMAT } from 'utils/constants';
import { representDate } from 'utils/formatters';

export default function ProjectSidebarHeader({ project }) {
  const tsStart = representDate(project.tsStart, DATE_FORMAT);
  const tsEnd = representDate(project.tsEnd, DATE_FORMAT);

  const organisationLogoUrl = project.owningOrganisation?.logoUrl;

  return (
    <>
      <Grid container sx={{ alignItems: 'center', flexDirection: 'column', p: 1 }}>
        <ProjectLogo
          projectName={project.name}
          projectLogoUrl={project.projectLogoUrl}
          organisationLogoUrl={organisationLogoUrl}
        />
        <Typography
          variant="h6"
          sx={{
            whiteSpace: 'wrap',
            textAlign: 'center',
            mb: 2,
            px: 1,
          }}
        >
          {project.name}
        </Typography>
        <Stack direction="column" alignItems="center">
          <Typography variant="subtitle1">{tsStart}</Typography>
          <Typography variant="subtitle1" mb={2}>
            {tsEnd}
          </Typography>
        </Stack>
      </Grid>
      <Divider />
    </>
  );
}
